export abstract class Environment {
    abstract readonly production: boolean
    abstract readonly version: string
    abstract readonly sentryDSN: string
    abstract readonly defaultBirdSamplingMethod: number
    abstract readonly admin: boolean
}
